import React, { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, ref, string } from "yup";
import { t } from "i18next";

import ResetPasswordForm, { ResetPasswordFormValues } from "./ResetPasswordForm";

import { useResetPassword } from "@api";

const schema = object({
  password: string().min(8).max(128).required(t("validation.required")),
  confirmPassword: string()
    .oneOf([ref("password")], t("auth.passwordsDontMatch"))
    .required(t("validation.required")),
}).required();

interface Props {
  onExpired?: () => void;
  onSuccess?: () => void;
}

const ResetPasswordFormContainer: FC<Props> = ({ onExpired, onSuccess }) => {
  const params = new URLSearchParams(window.location.search);
  const urlToken = params.get("token");
  const { control, setError, formState } = useForm<ResetPasswordFormValues>({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
    resolver: yupResolver(schema),
  });

  const { resetPassword, isPendingResetPassword, isSuccessResetPassword } =
    useResetPassword({ setError, onExpired });

  const onSubmit = (values: ResetPasswordFormValues): void => {
    if (urlToken) {
      resetPassword({
        password: values.password,
        confirmPassword: values.confirmPassword,
        token: urlToken,
      });
    }
  };

  useEffect(() => {
    if (isSuccessResetPassword) {
      onSuccess?.();
    }
  }, [isSuccessResetPassword]);

  return (
    <ResetPasswordForm
      {...{ onSubmit }}
      control={control}
      formState={formState}
      submitting={isPendingResetPassword}
    />
  );
};

export default ResetPasswordFormContainer;
